import { signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import React, { useState, useEffect } from "react";
import { auth } from "./firebase";
import { toast } from "react-toastify";
import SignInwithGoogle from "./signInWithGoogle";
import { useNavigate, Link } from "react-router-dom";
import "./LoginForm.css";
import { FaUser, FaLock } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { fetchData, selectIsLoading } from "../../mainApp/features/DataSlice/dataSlice";
import LoadingPage from "../components/TechnicalTabs/LoadingPage";
import ErrorPage from "../components/TechnicalTabs/ErrorPage";
import { translateFirebaseError } from "./Utility/firebaseErrorTranslator";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isLoggingIn, setIsLoggingIn] = useState(false); // Śledzi proces logowania
  const [showVerificationInfo, setShowVerificationInfo] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const loginToastId = 'login-error-toast';

  useEffect(() => {
    dispatch(fetchData());
  }, [dispatch]);

  useEffect(() => {
    // Monitoruj zalogowanego użytkownika
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Przekieruj tylko, jeśli użytkownik jest zalogowany i nie trwa proces logowania
    if (user && !isLoggingIn) {
      navigate("/profile");
    }
  }, [user, isLoggingIn, navigate]);

  useEffect(() => {
    if (isLoading === "success") {
      setInitialLoading(false);
    }
  }, [isLoading]);

  const handleResendVerificationEmail = async () => {
    if (!email) {
      toast.error("Wprowadź adres e-mail, aby ponownie wysłać link.", { position: "top-center" });
      return;
    }
    if (!password) {
      toast.error("Wprowadź hasło, aby ponownie wysłać link.", { position: "top-center" });
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user && !user.emailVerified) {
        await sendEmailVerification(user);
        toast.success("Link weryfikacyjny został wysłany ponownie.", { position: "top-center" });
      } else if (user && user.emailVerified) {
        toast.info("Twoje konto jest już zweryfikowane.", { position: "top-center" });
      }
      
      await auth.signOut();
    } catch (error) {
      const translatedError = translateFirebaseError(error.code, 'login');
      toast.error(translatedError, {
        position: "top-center",
        toastId: 'resend-error-toast'
      });
      if (auth.currentUser) {
        await auth.signOut();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoggingIn) return; // Zapobiegaj wielokrotnym próbom logowania
    setIsLoggingIn(true);
    setShowVerificationInfo(false);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      
      if (userCredential.user && !userCredential.user.emailVerified) {
        await auth.signOut();
        toast.error("Musisz najpierw zweryfikować swój adres e-mail. Kliknij w link aktywacyjny wysłany na Twoją skrzynkę.", {
          position: "top-center",
          toastId: loginToastId
        });
        setShowVerificationInfo(true);
        setIsLoggingIn(false);
        return;
      }

      toast.success("Logowanie zakończone sukcesem", {
        position: "top-center",
        autoClose: 1000,
      });
      setTimeout(() => {        setIsLoggingIn(false);
        navigate("/profile", { replace: true });
      }, 1000);
    } catch (error) {
      console.log(error.message);
      const translatedError = translateFirebaseError(error.code, 'login');
      toast.error(translatedError, {
        position: "bottom-center",
        toastId: loginToastId
      });
      setIsLoggingIn(false);
    }
  };

  let returned;

  switch (isLoading) {
    case "loading":
      returned = <LoadingPage />;
      break;
    case "success":
      returned = (
        <>
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <h1>Logowanie</h1>
            <div className="input-box">
              <input
                type="email"
                placeholder="Wprowadź email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <FaUser className="icon" />
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Wprowadź hasło"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FaLock className="icon" />
            </div>

            <button type="submit" disabled={isLoggingIn}>
              Zaloguj
            </button>

            <div className="register-link">
              <p>
                Nie masz konta?{" "}
                <a href="/register">Zarejestruj się!</a>
              </p>
              <p>
                <a href="/reset-password">Zapomniałeś hasła?</a>
              </p>
            </div>
            <SignInwithGoogle setIsLoggingIn={setIsLoggingIn} />
            
            <div className="legal-links">
              <Link to="/regulations">Regulamin</Link>
              <span className="separator">|</span>
              <Link to="/policy">Polityka Prywatności</Link>
            </div>
          </form>
          
        </div>
           
            {showVerificationInfo && (
              <div className="wrapper" style={{marginTop: "20px", textAlign: "center"}}>
                  <h4>Link weryfikacyjny nie przyszedł?</h4>
                  <a href="#" onClick={(e) => { e.preventDefault(); handleResendVerificationEmail(); }} style={{textDecoration: 'underline', cursor: 'pointer', color: 'white', display: 'inline-block', marginBottom: '5px', marginTop: '15px', fontSize: '14px'}}>Wyślij ponownie</a>
                  <div className="resend-tips" >
                      <p className="tips-header" style={{fontWeight: 'bold'}}>Wskazówki:</p>
                      <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0}}>
                          <li>Sprawdź folder spam.</li>
                          <li>Upewnij się, że przy rejestracji nie zrobiłeś literówki.</li>
                          <li>Zarejestruj się jeszcze raz, upewniając się, że podajesz właściwy adres e-mail.</li>
                      </ul>
                  </div>
              </div>
            )}
            </>
      );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
}

export default Login;